// extracted by mini-css-extract-plugin
module.exports = {"buttonWrap":"_mTgjplefBZKDMbqGPFYH","menu":"_2V8ztTEQJsaR4Gk7ujNLD1","list":"_65dOBrjL5fI2ss2v934Y8"};